import React from 'react'
import { SupplierConciliationDetailView } from './logic/SupplierConciliationDetailView'

export const SupplierConciliationShow = () => {
  return <SupplierConciliationDetailView isReadOnly={true} />
}

